import React from "react";

interface ArticleTocProps {
  items: { id: string; text: string }[];
  title?: string;
}

const ArticleToc: React.FC<ArticleTocProps> = ({ items, title = "On this page" }) => {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Table of contents"
      className="my-8 rounded-xl border border-lavender/30 bg-lavender/5 p-5"
    >
      <p className="text-xs uppercase tracking-wider font-semibold text-deep-blue/70 font-sans mb-3">
        {title}
      </p>
      <ol className="space-y-1.5 list-decimal pl-5 marker:text-teal-green marker:font-semibold">
        {items.map((it) => (
          <li key={it.id} className="text-sm font-sans">
            <a
              href={`#${it.id}`}
              className="text-deep-blue/80 hover:text-teal-green underline-offset-2 hover:underline"
            >
              {it.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default ArticleToc;
